module.exports = __webpack_public_path__ + "static/uxpin_notepad_5-9ad2378918dfad1852898bfa35df4984.png";